export { default } from '@atlassian/jira-spa-apps-next-gen-backlog/src/ui/backlog/index.tsx';
